export default {
  cart: (state) => state.cart,
};
